import React, { useEffect, useRef } from "react";
import styles from "./styles.module.scss";

interface ListItemProps {
  active?: boolean;
  children?: React.ReactNode;
  className?: string;
  scrollIntoView?: boolean;
  [key: string]: unknown;
}

const ListItem: React.FC<ListItemProps> = ({
  active = false,
  children = "",
  className = "",
  scrollIntoView = false,
  ...otherProps
}) => {
  const containerRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!scrollIntoView) return;
    containerRef.current?.scrollIntoView({
      block: "nearest",
      inline: "nearest",
      behavior: "smooth",
    });
  }, [scrollIntoView]);

  const classNames = [
    className,
    "list-item",
    styles.listItem,
    active && "active",
    active && styles.active,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      ref={containerRef}
      className={classNames}
      type="button"
      {...otherProps}
    >
      {children}
    </button>
  );
};

export default ListItem;
